import React from 'react';
import { Box, Paper, Typography } from '@material-ui/core';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { useUserQuery } from 'graphql/types';
import { useSnackbarContext } from 'common/context';
import { Link } from 'common/components/Link/Link';
import { useAuth } from 'auth/hooks';
import { getIntlPath } from 'common/utils';

interface IProps {
    className?: string;
}

const BaseUserAccountDisplay = ({ className }: IProps) => {
    const [showPopup, setShowPopup] = React.useState(false);

    const { setSnackbarState } = useSnackbarContext();
    const { data } = useUserQuery({
        onError: (error) => {
            setSnackbarState({
                message: error.message,
                variant: 'error',
            });
        },
    });
    const { logout } = useAuth();
    const history = useHistory();
    const { t } = useTranslation();

    const { user } = data || {};

    const handlePopoverOpen = () => {
        setShowPopup(true);
    };

    const handlePopoverClose = () => {
        setShowPopup(false);
    };

    const handleLogout = () => {
        logout();

        history.push(getIntlPath('login'));
    };

    return (
        <Box
            className={className}
            onMouseEnter={handlePopoverOpen}
            onMouseLeave={handlePopoverClose}
        >
            {showPopup && (
                <Paper className="popup">
                    <Link to={getIntlPath('account')}>
                        {t('user.toAccount')}
                    </Link>
                    <Link to="" onClick={handleLogout}>
                        {t('user.logout')}
                    </Link>
                </Paper>
            )}
            {user && (
                <>
                    <Box>
                        <Typography
                            className="nameUser"
                            color="primary"
                            variant="body2"
                        >
                            {`${user.firstName} ${user.lastNamePrefix} ${user.lastName}`}
                        </Typography>
                    </Box>

                    <Typography color="textSecondary" variant="body2">
                        {user.company.name}
                    </Typography>
                </>
            )}
        </Box>
    );
};

export const UserAccountDisplay = styled(BaseUserAccountDisplay)`
    width: 100%;
    cursor: pointer;

    .nameUser {
        font-weight: 700;
    }

    .popup {
        margin-bottom: 10px;
        padding: 10px;

        ${Link} {
            width: 100%;
            padding: 10px;
            text-decoration: none;

            &:hover {
                background-color: ${({ theme }) => theme.palette.grey[50]};
            }
        }
    }
`;
